export default "__VITE_ASSET__CC3CXWMi__"